import React from "react";
import { connect } from "react-redux";
import { Button, Tabs } from "antd";
import {
  Route
  // Link
} from "react-router-dom";

import "./SystemSettings.css";

import * as URLs from "../../common/constants/systemUrls";

import { interfaceActions } from "../../common/redux/actions";
import MyProfile from "./containers/MyProfile/MyProfile";
// import MyPerformers from './containers/MyPerformers/MyPerformers';
// import MyFilters from './containers/MyFilters/MyFilters';
// import MyTemplates from '../Templates/containers/Templates/Templates';
import MyExecutors from "../Executors/containers/Executors/Executors";
import Licensee from "./containers/Licensee/Licensee";

const { setCaption } = interfaceActions;

const { TabPane } = Tabs;

function getLastPathSegment(path) {
  const segments = path.split("/");
  return segments[segments.length - 1];
}

class SystemSettings extends React.Component {
  componentDidMount() {
    this.props.setCaption({
      enabled: true,
      mainCaption: "Настройки системы",
      breadCrumbs: [
        { path: "/" + URLs.CONTROL_PANEL, breadcrumbName: "Панель управления" },
        {
          path: "/" + URLs.SYSTEM_SETTINGS,
          breadcrumbName: "Настройки системы"
        }
      ]
    });
  }
  onTabsChange = key => {
    let { match, history } = this.props;

    switch (key) {
      case "profile": {
        history.push(match.path + "/profile");
        break;
      }
      case "performers": {
        history.push(match.path + "/performers");
        break;
      }
      case "signatures_and_seals": {
        history.push(match.path + "/signatures_and_seals");
        break;
      }
      case "payment_data": {
        history.push(match.path + "/payment_data");
        break;
      }
      case "access_control": {
        history.push(match.path + "/access_control");
        break;
      }
      case "notifications": {
        history.push(match.path + "/notifications");
        break;
      }
      case "filters": {
        history.push(match.path + "/filters");
        break;
      }
      case "templates": {
        history.push(match.path + "/templates");
        break;
      }
      case "executors": {
        history.push(match.path + "/executors");
        break;
      }
      case "licensee": {
        history.push(match.path + "/licensee");
        break;
      }
      default:
        break;
    }
  };
  render() {
    let { match, location, activeProfile } = this.props;
    return (
      <div id="system_settings" className="basicForm">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            position: "relative"
          }}
        >
          <Button
            type="primary"
            size="large"
            disabled={false}
            style={{
              position: "absolute",
              top: "100%",
              backgroundColor: "#ffffff",
              color: "#00A8FF",
              zIndex: 10
            }}
            onClick={() => {
              this.props.history.push(
                "/" + URLs.AUTHORIZATION + "/" + URLs.ADD_PROFILE
              );
            }}
          >
            Добавить лицензию
          </Button>
        </div>
        <Tabs
          type="card"
          activeKey={getLastPathSegment(location.pathname)}
          onChange={this.onTabsChange}
        >
          <TabPane tab="Мой профиль" key="profile">
            <Route
              path={match.path + "/profile"}
              render={props => <MyProfile {...props} />}
            />
          </TabPane>
          {activeProfile && activeProfile.roleId === 2 && (
            <TabPane tab="Лицензиат" key="licensee">
              <Route
                path={match.path + "/licensee"}
                render={props => <Licensee {...props} />}
              />
            </TabPane>
          )}
          <TabPane tab="Мои исполнители" key="executors">
            <Route
              path={match.path + "/executors"}
              render={props => <MyExecutors {...props} />}
            />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default connect(
  state => ({
    activeProfile: state.Authorization.activeProfile
  }),
  {
    setCaption
  }
)(SystemSettings);
